<template>
  <div id="ca-cert">
    <b-container class="container--max-1000">
      <div class="mb-3">
        <h1>{{ $t("lang.label_caCert") }}</h1>
      </div>
      <div class="mb-3">
        <router-link class="c-link" to="/dashboard">
          <mtg-icon icon="ic-angle-left"></mtg-icon>
          <span>{{ $t("lang.label_back") }}</span>
        </router-link>
      </div>
      <div class="c-dashboard__card">
        <b-card v-for="ca in caCertificates" v-bind:key="ca.id" class="mb-2">
          <b-card-text>
            <b-table-simple responsive>
              <b-tbody>
                <b-tr>
                  <b-td rowspan="8">
                    <h4 v-html="$options.filters.commonNameFormatter(ca.root.caPublicKeyAlgorithm)"></h4>
                    <b-img fluid class="mt-6" v-if="ca.root.caPublicKeyAlgorithm === 'SPX' || ca.root.caPublicKeyAlgorithm === 'CME'" src="images/layout/illu-post-quantum-certificate.png"></b-img>
                    <b-img fluid class="mt-6" v-else src="images/layout/illu-traditional-certificate.png"></b-img>
                  </b-td>
                  <b-th class="text-center" colspan="3" v-html="$options.filters.commonNameFormatter(ca.root.subjectCommonName) + '<br />(Root)'"></b-th>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">{{ $t("lang.label_caCert_validNotAfter") }}</b-th>
                  <b-td>{{ ca.root.validNotAfter | dateFormatter }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">{{ $t("lang.label_caCert_fingerprint") }}</b-th>
                  <b-td style="word-break: break-word">{{ ca.root.fingerprint }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">{{ $t("lang.label_caCert_pem") }}</b-th>
                  <b-td>
                    <b-button class="btn--has-icon mb-1" variant="primary" @click="downloadCaCertificate(ca.root.id)">
                      <mtg-icon icon="ic-download"></mtg-icon>
                      <span>{{ $t("lang.label_certificate_download") }}</span>
                    </b-button>
                  </b-td>
                </b-tr>

                <b-tr>
                  <b-th class="text-center" colspan="3" v-html="$options.filters.commonNameFormatter(ca.intermediate.subjectCommonName) + '<br />(Intermediate)'"></b-th>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">{{ $t("lang.label_caCert_validNotAfter") }}</b-th>
                  <b-td>{{ ca.intermediate.validNotAfter | dateFormatter }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">{{ $t("lang.label_caCert_fingerprint") }}</b-th>
                  <b-td style="word-break: break-word">{{ ca.intermediate.fingerprint }}</b-td>
                </b-tr>
                <b-tr>
                  <b-th class="text-right">{{ $t("lang.label_caCert_pem") }}</b-th>
                  <b-td>
                    <b-button class="btn--has-icon mb-1" variant="primary" @click="downloadCaCertificate(ca.intermediate.id)">
                      <mtg-icon icon="ic-download"></mtg-icon>
                      <span>{{ $t("lang.label_certificate_download") }}</span>
                    </b-button>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card-text>
        </b-card>
      </div>
    </b-container>
  </div>
</template>
<style scoped></style>

<script>
import API from "@/api";
import * as moment from "moment/moment";
import * as utils from "@/utils";

export default {
  data() {
    return {
      caCertificates: []
    };
  },
  created() {
    this.getCaCerts();
  },
  filters: {
    dateFormatter(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    commonNameFormatter(value) {
      if (value.includes("SPX")) {
        return value.replace("SPX", "Sphincs<sup>+</sup>");
      } else {
        return value;
      }
    }
  },
  methods: {
    getCaCerts() {
      this.$store.dispatch("startLoading");
      API.getCaCertificates()
        .then(response => {
          this.$store.dispatch("stopLoading");
          this.caCertificates = response.data;
        })
        .catch(() => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch("alert/showFailureAlert", "Could not load CA certificates");
        });
    },
    downloadCaCertificate(id) {
      this.$store.dispatch("startLoading");
      API.downloadCaCertificate(id)
        .then(response => {
          this.$store.dispatch("stopLoading");
          utils.downloadCertFile(response.data.fileName, response.data.pemCertificate);
        })
        .catch(() => {
          this.$store.dispatch("stopLoading");
          this.$store.dispatch("alert/showFailureAlert", this.$t("lang.message_certificate_download_error_message"));
        });
    }
  }
};
</script>
